import { useQuery } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import type { ListRequest, Paged } from "@/core/api/pagination";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { ledgerEndpoints } from "@/features/ledger/api/endpoints";
import type {
  ProductCodeDto,
  ProductCodeFilter,
} from "@/features/ledger/api/dto";

/**
 * Codes produits paginés (`POST /ProductCodes/all`, guide §4.2) — un code
 * produit est la clé de résolution du modèle d'imputation et de la règle
 * de frais.
 */
export const useProductCodes = (
  params: ListRequest<ProductCodeFilter> = {},
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.LEDGER_PRODUCT_CODES_LIST(params),
    queryFn: () =>
      mutateData({
        url: ledgerEndpoints.productCodes.all,
        reqBody: params as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<Paged<ProductCodeDto>>,
    enabled,
  });
